module.exports = __webpack_public_path__ + "static/img/1.cdf929f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/1.png
// module id = hRtF
// module chunks = 0